export default {
    API_ENDPOINT: 'https://shielded-shelf-30672.herokuapp.com'
};